import Mixin from '../Mixin';
import FDictionaryShip from '@/modules/Dictionary/Ship/Select';
import FDictionaryServiceDescription1 from '@/modules/Dictionary/ServiceDescription1/Select';
import FDictionaryServiceDescription2 from '@/modules/Dictionary/ServiceDescription2/Select';

import component from './component.vue';

export default class extends Mixin {
  component = component;

  ship = new FDictionaryShip({
    label: 'Доп.услуги в круизе',
    required: true,
  });

  description1 = new FDictionaryServiceDescription1({
    label: 'Описание 1',
  });

  description2 = new FDictionaryServiceDescription2({
    label: 'Описание 2',
  });

  constructor(props) {
    super(props);
    this.service.set({
      value: 9,
      label: 'Доп.услуги в круизе',
    });
    this.setItems([
      ['ship', this.ship],
      ['description1', this.description1],
      ['description2', this.description2],
    ]);
    this.ship.service = this.service;
    this.description1.service = this.service;
    this.description2.service = this.service;
  }


  set(value = {}) {
    super.set(value);
    this.__set('ship', value.ship, null);
    this.__set('description1', value.description1, null);
    this.__set('description2', value.description2, null);
    return this;
  }

  toString() {
    return this.ship.toString();
  }

  getCountCol(){
    return  this.countCol;
  }

  submit() {
    return super.submit()
      .then((data) => {
        this.name = this.ship.toLabel();
        return data;
      });
  }
}
